import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule as FormlyCoreSelectModule } from '@ngx-formly/core/select';

import { TaFormlyFieldWrapperModule } from '@ta-formly/ta-field-wrapper/ta-field-wrapper.module';
import { TaCheckboxComponent } from './ta-checkbox.type';

@NgModule({
    declarations: [TaCheckboxComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        IonicModule,

        TaFormlyFieldWrapperModule,
        FormlyCoreSelectModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'ta-checkbox',
                    component: TaCheckboxComponent,
                    wrappers: ['ta-field-wrapper']
                }
            ]
        })
    ]
})
export class TaFormlyCheckboxModule { }
